import { Box, Image } from "@prismicio/editor-ui"

// Note: this is a wroom component because we don't want editor-ui to come with assets that must be copied over in apps.

interface Props {
  /**
   * A Prismic locale, e.g, en-us or ca.
   */
  locale: string
}

export function Flag(props: Props) {
  const { locale } = props

  const flag = getFlag(locale)
  const src = getFlagPath(flag)

  if (!src) return null

  return (
    <Box height={20} width={26} border backgroundColor="grey5" flexShrink={0}>
      <Image
        src={src}
        alt={`${flag} flag`}
        sizing="cover"
        loading="lazy"
        animateOnLoad={false}
      />
    </Box>
  )
}

export function getFlag(locale: string) {
  const [language, region] = locale.split("-")
  return (prismicToISO.get(locale) ?? region ?? language) || defaultFlag
}

function getFlagPath(flag: string) {
  return flagNameToURL.get(flag) ?? flagNameToURL.get(defaultFlag)
}

const flagNameToURL = new Map(
  Object.entries(
    import.meta.glob(`./flags/*.svg`, {
      query: "?url",
      import: "default",
      eager: true,
    }),
  ).flatMap(([localPath, url]) => {
    // Should not happen; meta.glob's type signature is not great.
    if (typeof url !== "string") return []

    const fileName = localPath.slice(localPath.lastIndexOf("/") + 1)
    const flagName = fileName.slice(0, fileName.lastIndexOf("."))
    return [[flagName, url]]
  }),
)

const defaultFlag = "flag-default"

/**
 * Some Prismic locales are not standard, so we need to map them to the closest ISO language code.
 * Set the locale stored in PrismicDB as the key and the ISO language code as the value to ensure the correct flag is displayed.
 */
const prismicToISO = new Map([
  ["ca", "es-ct"], // Catalan
  ["vi", "vn"], // Vietnamese
])
